/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateManpowerSettingCommand } from '../../models/create-manpower-setting-command';
import { CreateManpowerSettingCommandResult } from '../../models/create-manpower-setting-command-result';

export interface ApiManpowerSettingCreateManpowerSettingPost$Plain$Params {
  
    /**
     * The command containing the details for the new manpower setting.
     */
    body?: CreateManpowerSettingCommand
}

export function apiManpowerSettingCreateManpowerSettingPost$Plain(http: HttpClient, rootUrl: string, params?: ApiManpowerSettingCreateManpowerSettingPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateManpowerSettingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiManpowerSettingCreateManpowerSettingPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateManpowerSettingCommandResult>;
    })
  );
}

apiManpowerSettingCreateManpowerSettingPost$Plain.PATH = '/api/ManpowerSetting/CreateManpowerSetting';
